<template>
  <div class="categoryGridpanel">
    <div
      v-for="({ name, paragraph }, key) in $t('categoryNew')"
      :class="`ctgCol ctg${key}`"
      @click="key === 'livetv91' ? openTv91() : handleCategorySelectHome(key)"
    >
      <router-link :to="key === 'livetv91' ? '' : `/rooms?${key}`">
        <div class="img-box">
          <img :src="require(`@/assets/images/ctg${key}.png`)" />
        </div>
        <div class="dtlbox">
          <h2>{{ name }}</h2>
          <p>{{ paragraph }}</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie'
import router from 'vue-router'

export default {
  name: 'CategoryCards',
  props: ['room_id', 'whatsNewmodelOpen', 'channel'],
  data() {
    return {
      previousCategoryViewer: '',
      selectedCategoryViewer: this.$store.getters.selected
    }
  },
  methods: {
    handleCards() {
      this.$emit('handleCards')
    },
    handleCategorySelectHome(category) {
      this.previousCategoryViewer = this.selectedCategoryViewer
      this.$socket.emit('categories_wise_live_user', { category: category })
      this.selectedCategoryViewer = category
      this.$store.commit('updateSelected', {
        selected: category
      })
      return
    },
    openTv91() {
      window.location.href =
        'http://tv.money91.com/#/login-via-url/' + Cookies.get('X-Auth-Id') ||
        null + '?lng=' + Cookies.get('lang')
      // console.log('tag', 'http://tv.money91.com/#/login-via-url/' +
      // Cookies.get('X-Auth-Id') +
      // '?lng=' +
      // Cookies.get('lang'))
    }
  },
  sockets: {}
}
</script>
